import { IBoundEmail, IGetBoundEmailsParams } from 'multirpc-sdk';

import { MultiService } from 'modules/api/MultiService';
import { RequestType, web3Api } from 'store/queries';
import { createNotifyingQueryFn } from 'store/utils/createNotifyingQueryFn';
import { createQuerySelectors } from 'store/utils/createQuerySelectors';

export interface IFetchBoundEmailsParams extends IGetBoundEmailsParams {}

/**
 * This action fetches emails that are used as login methods for the user with current confirmation status.
 * */

// The endpoint name is listed in endpointsSerializedByParams constant
// in packages/protocol/src/store/queries/index.ts file.
// If the name has changed it should be reflected there as well.
export const {
  endpoints: { fetchBoundEmails },
  useFetchBoundEmailsQuery,
  useLazyFetchBoundEmailsQuery,
} = web3Api.injectEndpoints({
  endpoints: build => ({
    fetchBoundEmails: build.query<IBoundEmail[], IFetchBoundEmailsParams>({
      providesTags: [RequestType.BoundEmails],
      queryFn: createNotifyingQueryFn(async params => {
        const api = MultiService.getService().getAccountingGateway();

        const data = await api.getBoundEmails(params);

        return { data };
      }),
    }),
  }),
  overrideExisting: true,
});

const fetchBoundEmailsFallback: IBoundEmail[] = [];

export const {
  selectDataWithFallbackCachedByParams: selectBoundEmails,
  selectLoadingCachedByParams: selectBoundEmailsLoading,
  selectStateCachedByParams: selectBoundEmailsState,
} = createQuerySelectors({
  endpoint: fetchBoundEmails,
  fallback: fetchBoundEmailsFallback,
});
